export default __webpack_public_path__ + "static/media/handprint-20-21-page.c7d0ed89.png";